// Catálogo legible de módulos y permisos: qué ve y qué puede hacer el cliente en su
// dashboard. `menu` es el nombre con que aparece en el menú del dashboard
// (null = no tiene entrada de menú propia). Al agregar un módulo o permiso nuevo
// en CurrentModulesHandle.js, agrégalo aquí con su explicación.

export const MODULE_GROUPS = [
  { key: 'atencion', label: 'Atención al cliente' },
  { key: 'ventas', label: 'Ventas y leads' },
  { key: 'catalogo', label: 'Catálogo' },
  { key: 'rh', label: 'Reclutamiento' },
  { key: 'operacion', label: 'Operación' },
  { key: 'inteligencia', label: 'Inteligencia' },
];

export const MODULE_INFO = {
  chats: { group: 'atencion', name: 'Chats', menu: 'Chats', description: 'Las conversaciones del agente en WhatsApp, web y llamadas. El cliente las lee y puede responder.' },
  contactos: { group: 'atencion', name: 'Contactos', menu: null, description: 'Las personas que han escrito al agente.' },
  'horarios de atención': { group: 'atencion', name: 'Horarios de atención', menu: 'Horarios de Atención', description: 'Horario en que el agente atiende o pasa la conversación a una persona.' },
  grupos: { group: 'atencion', name: 'Grupos', menu: 'Grupos', description: 'Listas de contactos para enviar mensajes a muchos a la vez.' },
  citas: { group: 'atencion', name: 'Citas', menu: 'Citas', description: 'La agenda de citas que genera el agente.' },
  aprendizaje: { group: 'atencion', name: 'Aprendizaje', menu: 'Aprendizaje', description: 'Los documentos con los que el agente aprende a responder.' },

  leads: { group: 'ventas', name: 'Leads', menu: 'Leads', description: 'Los clientes potenciales que el agente registra y califica.' },
  'dashboard leads': { group: 'ventas', name: 'Tablero de leads', menu: 'Dashboard Leads', description: 'Gráficas de leads por curso, mes y región.' },
  'leads inmobiliaria': { group: 'ventas', name: 'Leads inmobiliarios', menu: 'Inmobiliaria Leads', description: 'Leads de casas y terrenos con su desarrollo de interés.' },
  'leads universidad': { group: 'ventas', name: 'Leads de universidad', menu: 'Leads Universidad', description: 'Aspirantes interesados en programas educativos.' },
  cotizaciones: { group: 'ventas', name: 'Cotizaciones', menu: 'Cotizaciones', description: 'Las cotizaciones que genera el agente.' },
  vendedores: { group: 'ventas', name: 'Vendedores', menu: 'Vendedores', description: 'El equipo de ventas al que el agente asigna clientes.' },
  crm_products: { group: 'ventas', name: 'Productos CRM', menu: 'Productos CRM', description: 'Productos con precio que el agente usa para cotizar.' },

  productos: { group: 'catalogo', name: 'Productos', menu: 'Productos', description: 'El catálogo de productos que el agente ofrece.' },
  servicios: { group: 'catalogo', name: 'Servicios', menu: 'Servicios', description: 'Los servicios que el agente ofrece y agenda.' },
  desarrollos: { group: 'catalogo', name: 'Desarrollos', menu: 'Desarrollos', description: 'Los desarrollos inmobiliarios (viviendas y terrenos) que el agente presenta.' },

  prospectos: { group: 'rh', name: 'Prospectos', menu: 'Prospectos', description: 'Candidatos a vacantes que el agente entrevista.' },
  perfiles: { group: 'rh', name: 'Perfiles de puesto', menu: 'Perfiles', description: 'Las vacantes y sus requisitos.' },

  procesos: { group: 'operacion', name: 'Procesos', menu: 'Procesos', description: 'Documentación de procesos de la empresa que consulta el agente.' },
  'usuarios procesos': { group: 'operacion', name: 'Usuarios de procesos', menu: 'Usuarios Procesos', description: 'Quién puede consultar los procesos.' },
  tickets: { group: 'operacion', name: 'Tickets', menu: 'Tickets', description: 'Solicitudes de soporte que levanta el agente.' },
  pagos: { group: 'operacion', name: 'Pagos', menu: 'Pagos', description: 'Pagos y cobros registrados.' },
  envios: { group: 'operacion', name: 'Canales de envío', menu: 'Envíos', description: 'El cliente conecta su correo o WhatsApp para recibir ahí los avisos de la plataforma (Avisos de IA).' },

  inteligencia: {
    group: 'inteligencia', name: 'Inteligencia', menu: null,
    description: 'Avisos de IA: revisamos los datos todos los días y avisamos al cliente cuando algo cambia (botón ✨ en el encabezado).',
  },
};

export const ACTION_INFO = {
  read: { label: 'Ver' },
  create: { label: 'Crear' },
  update: { label: 'Editar' },
  delete: { label: 'Eliminar' },
  status: { label: 'Activar o desactivar' },
};

export const SPECIAL_INFO = {
  export: { label: 'Exportar a Excel' },
  human_atention: { label: 'Tomar el control del chat', help: 'Pausa al agente para que una persona responda.' },
  export_chat: { label: 'Exportar una conversación' },
  delete_chat: { label: 'Borrar conversaciones' },
  can_block_contact: { label: 'Bloquear contactos', help: 'El agente deja de responderle a ese contacto.' },
  create_chat: { label: 'Iniciar chats nuevos', help: 'Escribirle primero a un contacto con una plantilla de WhatsApp.' },
  filters: { label: 'Filtros de campaña y entidad' },
  can_view_budget_filter: { label: 'Marca de presupuesto', help: 'Marcar chats en los que hay que hablar de presupuesto y filtrarlos.' },
  can_view_follow_up_filter: { label: 'Marca de fecha posterior', help: 'Marcar chats para retomarlos después de un evento.' },
  can_view_notice_filter: { label: 'Marca de aviso', help: 'Marcar chats con un aviso pendiente.' },
  can_view_generic_filter: { label: 'Filtro por servicio' },
  link_documents_rh: { label: 'Liga para subir documentos', help: 'El candidato recibe una liga para enviar sus documentos.' },
  send_broadcast: { label: 'Enviar mensajes masivos' },
  can_view_qa: { label: 'Calidad de atención', help: 'Menú Calidad: embudo del agente y calificación diaria de sus conversaciones.' },
  can_send_from_assistant: { label: 'Correos desde el asistente', help: 'El asistente (chat y voz) busca personas y prepara correos individuales o en ráfaga; el cliente los revisa y los envía con un clic, con su correo conectado.' },
  can_edit_qa_criteria: { label: 'Criterios de calidad propios', help: 'El cliente agrega hasta 5 criterios para calificar las conversaciones.', requires: 'can_view_qa' },
};

export const moduleInfo = (key) =>
  MODULE_INFO[key] ?? { group: 'operacion', name: key.charAt(0).toUpperCase() + key.slice(1), menu: null, description: '' };

/** Entradas del menú del dashboard que verá el cliente con estos módulos (en orden del catálogo). */
export function clientMenu(modules) {
  const items = [{ key: 'inicio', label: 'Inicio' }];
  const byKey = Object.fromEntries((modules || []).map((m) => [m.module, m]));
  Object.entries(MODULE_INFO).forEach(([key, info]) => {
    const m = byKey[key];
    if (!m?.view) return;
    if (info.menu) items.push({ key, label: info.menu });
    if (key === 'inteligencia' && m.special_actions?.can_view_qa) items.push({ key: 'calidad', label: 'Calidad' });
  });
  return items;
}
